<template>
   <div class="crud-wrapper">
        <crud-toolbar :modal-mode="modalMode" :new-state="newState" :title="modalTitle" @onCommand="toolbarCommand"></crud-toolbar>

        <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">
            <div class="blocked-container" v-if="$moment().diff(formData.createdAt, 'days') > 0">
                <v-icon size="35" color="#4744e9">lock</v-icon>
                <div>
                    <h5>A campanha foi criada a mais de 24 horas.</h5>
                    <p>Para realizar uma correção, você deverá remover e criar uma nova campanha.</p>
                </div>
            </div>
            <v-layout row wrap>
                <a-text-field :disabled="$moment().diff(formData.createdAt, 'days') > 0" autofocus label="Título da Campanha" v-model="formData.title" validate="required" sm6></a-text-field>
                <a-text-field :disabled="$moment().diff(formData.createdAt, 'days') > 0" label="Código" maxLength="10" v-model="formData.slug" validate="required" sm6></a-text-field>
                <div v-if="formData.productLink" v-on:click="copyLink(formData.productLink)" style="width: 100%; cursor: pointer;" sm12>
                    <a-text-field disabled label="Clique para copiar link do produto" v-model="formData.productLink" sm12></a-text-field>
                </div>
                <a-select-field :disabled="$moment().diff(formData.createdAt, 'days') > 0" label="Produto" :suggestions="apps" validate="required" v-model="formData.appId" sm12></a-select-field>
            </v-layout>
        </crud-form>
   </div>
</template>

<script>
    import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';

    export default CrudFormClass.extend({
        name: 'CampaignForm',

        data () {
            return {
                title: 'Campanha',
                formName: 'campaignForm',

                formData: {
                    id: null,
                    title: null,
                    slug: null,
                    productLink: null,
                    appId: null,
                    createdAt: null
                },

                apps: [],
                referralCode: null
            };
        },

        watch: {
            'formData.appId' (newValue) {
                if (this.formData.appId || this.formData.slug)
                    if (this.formData.slug) 
                        this.formData.productLink = this.apps.find(app => app.id === newValue).link +  `/${this.referralCode}?src=${this.formData.slug}`;
                    else
                        this.formData.productLink = this.apps.find(app => app.id === newValue).link +  `/${this.referralCode}`;
                else
                    this.formData.productLink = null;
            },

            'formData.slug' (newValue) {
                if (this.formData.appId || this.formData.slug)
                    if (this.formData.appId) 
                        this.formData.productLink = this.apps.find(app => app.id === this.formData.appId).link +  `/${this.referralCode}?src=${newValue}`;
                    else 
                        this.formData.productLink = `/${this.referralCode}?src=${newValue}`;
                else
                    this.formData.productLink = null;
            }
        },

        async created() {
            this.apps = await this.$api.dataService.execute('campaign/getApps', {});

            try {
                var res = await this.$api.dataService.execute('client/getReferralCode', { pParam: true });
                
                if(res){
                    this.referralCode = res.referralCode;
                }
            } catch (e) {
                console.log(e);
            }
        },

        computed: {
            
        },

        methods: {
            beforeSave() {
                this.copyLink(this.formData.productLink, true);
            },

            copyLink(link, delay = false) {
                window.Clipboard.copy(link);

                if (delay) {
                    setTimeout(() => {
                        this.$notifyUser({
                            message: 'Campanha cadastrada e link copiado!'
                        });
                    }, 500);
                } else {
                    this.$notifyUser({
                        message: 'Link copiado!'
                    });
                }
            },
        }
    });
</script>

<style scoped>
    .blocked-container {
        width: 100%;
        background-color: #fafafa;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.15);
        border-radius: 5px;
        padding: 10px;
        margin-bottom: 15px;
        color: #4744e9;

        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .blocked-container > div {
        margin-left: 10px;
    }

    .blocked-container > div > h5 {
        font-weight: bold;
    }

    .blocked-container p {
        margin: 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/CampaignForm.vue